module.exports = __webpack_public_path__ + "media/images/bondform_spice2-1a33343d16f49e3d35aa2026b2e5f164.gif";